export const OBJECT_ACCESS_RIGHTS_LOAD = 'OBJECT_ACCESS_RIGHTS_LOAD';
export const OBJECT_ACCESS_RIGHTS_LOAD_SUCCESS = 'OBJECT_ACCESS_RIGHTS_LOAD_SUCCESS';
export const OBJECT_ACCESS_RIGHTS_LOAD_ERROR = 'OBJECT_ACCESS_RIGHTS_LOAD_ERROR';
export const OBJECT_ACCESS_RIGHTS_ADD = 'OBJECT_ACCESS_RIGHTS_ADD';
export const OBJECT_ACCESS_RIGHTS_ADD_SUCCESS = 'OBJECT_ACCESS_RIGHTS_ADD_SUCCESS';
export const OBJECT_ACCESS_RIGHTS_ADD_ERROR = 'OBJECT_ACCESS_RIGHTS_ADD_ERROR';
export const OBJECT_ACCESS_RIGHTS_UPDATE = 'OBJECT_ACCESS_RIGHTS_UPDATE';
export const OBJECT_ACCESS_RIGHTS_UPDATE_SUCCESS = 'OBJECT_ACCESS_RIGHTS_UPDATE_SUCCESS';
export const OBJECT_ACCESS_RIGHTS_UPDATE_ERROR = 'OBJECT_ACCESS_RIGHTS_UPDATE_ERROR';
export const OBJECT_ACCESS_RIGHTS_DELETE = 'OBJECT_ACCESS_RIGHTS_DELETE';
export const OBJECT_ACCESS_RIGHTS_DELETE_SUCCESS = 'OBJECT_ACCESS_RIGHTS_DELETE_SUCCESS';
export const OBJECT_ACCESS_RIGHTS_DELETE_ERROR = 'OBJECT_ACCESS_RIGHTS_DELETE_ERROR';
